import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_GENERATE_CRUD_PAGES_BEGIN,
  COLLECTIONS_GENERATE_CRUD_PAGES_SUCCESS,
  COLLECTIONS_GENERATE_CRUD_PAGES_FAILURE,
  COLLECTIONS_GENERATE_CRUD_PAGES_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function generateCrudPages(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_GENERATE_CRUD_PAGES_BEGIN,
    });
    const { projectId, collectionName, version, body } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/generateCRUD`,
        body,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.data && res.data.code === 200) {
            dispatch({
              type: COLLECTIONS_GENERATE_CRUD_PAGES_SUCCESS,
              data: res.data,
            });
            Mixpanel.track('CRUD Created for collection ', { collectionName });
            toast.success(res.data.message);
            resolve(res);
          } else {
            dispatch({
              type: COLLECTIONS_GENERATE_CRUD_PAGES_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to create CRUD for ', { collectionName });
            toast.error(`Failed to create CRUD for ${collectionName}`);
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_GENERATE_CRUD_PAGES_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to create CRUD for ', { collectionName });
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Failed: ${errMsg}` || 'Generate CRUD Failed !');
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGenerateCrudPagesError() {
  return {
    type: COLLECTIONS_GENERATE_CRUD_PAGES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_GENERATE_CRUD_PAGES_BEGIN:
      return {
        ...state,
        generateCrudPagesPending: true,
        generateCrudPagesError: null,
      };

    case COLLECTIONS_GENERATE_CRUD_PAGES_SUCCESS:
      return {
        ...state,
        generateCrudPagesPending: false,
        generateCrudPagesError: null,
      };

    case COLLECTIONS_GENERATE_CRUD_PAGES_FAILURE:
      return {
        ...state,
        generateCrudPagesPending: false,
        generateCrudPagesError: action.data.error,
      };

    case COLLECTIONS_GENERATE_CRUD_PAGES_DISMISS_ERROR:
      return {
        ...state,
        generateCrudPagesError: null,
      };

    default:
      return state;
  }
}
